import { render, staticRenderFns } from "./SuperAdminNotification.vue?vue&type=template&id=2be8105b"
import script from "./SuperAdminNotification.vue?vue&type=script&lang=js"
export * from "./SuperAdminNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports